// Top ~350 US cities by population — used as source for the "Current City"
// searchable dropdown in the Candidate Portal Dossier. Candidates can also
// type any custom city name if theirs is not on the list (see MultiSelect /
// SearchableSelect components — free-text-fallback enabled).
const RAW_CITIES = [
  "New York, NY","Los Angeles, CA","Chicago, IL","Houston, TX","Phoenix, AZ",
  "Philadelphia, PA","San Antonio, TX","San Diego, CA","Dallas, TX","San Jose, CA",
  "Austin, TX","Jacksonville, FL","Fort Worth, TX","Columbus, OH","Charlotte, NC",
  "Indianapolis, IN","San Francisco, CA","Seattle, WA","Denver, CO","Washington, DC",
  "Nashville, TN","Oklahoma City, OK","El Paso, TX","Boston, MA","Portland, OR",
  "Las Vegas, NV","Detroit, MI","Memphis, TN","Louisville, KY","Baltimore, MD",
  "Milwaukee, WI","Albuquerque, NM","Tucson, AZ","Fresno, CA","Sacramento, CA",
  "Kansas City, MO","Mesa, AZ","Atlanta, GA","Omaha, NE","Colorado Springs, CO",
  "Raleigh, NC","Long Beach, CA","Virginia Beach, VA","Miami, FL","Oakland, CA",
  "Minneapolis, MN","Tulsa, OK","Bakersfield, CA","Wichita, KS","Arlington, TX",
  "Aurora, CO","Tampa, FL","New Orleans, LA","Cleveland, OH","Anaheim, CA",
  "Honolulu, HI","Henderson, NV","Stockton, CA","Riverside, CA","Lexington, KY",
  "Corpus Christi, TX","Orlando, FL","Irvine, CA","Cincinnati, OH","Santa Ana, CA",
  "Newark, NJ","Saint Paul, MN","Pittsburgh, PA","Greensboro, NC","Durham, NC",
  "Lincoln, NE","Jersey City, NJ","Plano, TX","Anchorage, AK","North Las Vegas, NV",
  "St. Louis, MO","Madison, WI","Chandler, AZ","Gilbert, AZ","Reno, NV",
  "Buffalo, NY","Chula Vista, CA","Fort Wayne, IN","Lubbock, TX","Toledo, OH",
  "St. Petersburg, FL","Laredo, TX","Irving, TX","Chesapeake, VA","Winston-Salem, NC",
  "Glendale, AZ","Garland, TX","Scottsdale, AZ","Norfolk, VA","Boise, ID",
  "Fremont, CA","Spokane, WA","Santa Clarita, CA","Baton Rouge, LA","Richmond, VA",
  "Hialeah, FL","San Bernardino, CA","Tacoma, WA","Modesto, CA","Huntsville, AL",
  "Des Moines, IA","Yonkers, NY","Rochester, NY","Moreno Valley, CA","Fayetteville, NC",
  "Fontana, CA","Columbus, GA","Worcester, MA","Port St. Lucie, FL","Little Rock, AR",
  "Augusta, GA","Oxnard, CA","Birmingham, AL","Montgomery, AL","Frisco, TX",
  "Amarillo, TX","Salt Lake City, UT","Grand Rapids, MI","Huntington Beach, CA","Overland Park, KS",
  "Glendale, CA","Tallahassee, FL","Grand Prairie, TX","McKinney, TX","Cape Coral, FL",
  "Sioux Falls, SD","Peoria, AZ","Providence, RI","Vancouver, WA","Knoxville, TN",
  "Akron, OH","Brownsville, TX","Mobile, AL","Newport News, VA","Tempe, AZ",
  "Shreveport, LA","Chattanooga, TN","Fort Lauderdale, FL","Aurora, IL","Elk Grove, CA",
  "Ontario, CA","Salem, OR","Cary, NC","Santa Rosa, CA","Rancho Cucamonga, CA",
  "Eugene, OR","Oceanside, CA","Clarksville, TN","Garden Grove, CA","Lancaster, CA",
  "Springfield, MO","Pembroke Pines, FL","Fort Collins, CO","Palmdale, CA","Salinas, CA",
  "Hayward, CA","Corona, CA","Paterson, NJ","Murfreesboro, TN","Macon, GA",
  "Lakewood, CO","Killeen, TX","Springfield, MA","Alexandria, VA","Kansas City, KS",
  "Sunnyvale, CA","Hollywood, FL","Roseville, CA","Charleston, SC","Escondido, CA",
  "Joliet, IL","Jackson, MS","Bellevue, WA","Surprise, AZ","Naperville, IL",
  "Pasadena, TX","Pomona, CA","Bridgeport, CT","Denton, TX","Rockford, IL",
  "Mesquite, TX","Savannah, GA","Syracuse, NY","McAllen, TX","Torrance, CA",
  "Olathe, KS","Visalia, CA","Thornton, CO","Fullerton, CA","Gainesville, FL",
  "Waco, TX","West Valley City, UT","Warren, MI","Hampton, VA","Dayton, OH",
  "Columbia, SC","Orange, CA","Cedar Rapids, IA","Stamford, CT","Victorville, CA",
  "Pasadena, CA","Elizabeth, NJ","New Haven, CT","Miramar, FL","Kent, WA",
  "Sterling Heights, MI","Carrollton, TX","Coral Springs, FL","Midland, TX","Norman, OK",
  "Athens, GA","Santa Clara, CA","Columbia, MO","Fargo, ND","Pearland, TX",
  "Simi Valley, CA","Meridian, ID","Topeka, KS","Allentown, PA","Thousand Oaks, CA",
  "Abilene, TX","Vallejo, CA","Concord, CA","Round Rock, TX","Arvada, CO",
  "Clovis, CA","Palm Bay, FL","Independence, MO","Lafayette, LA","Ann Arbor, MI",
  "Rochester, MN","Hartford, CT","College Station, TX","Fairfield, CA","Wilmington, NC",
  "North Charleston, SC","Billings, MT","West Palm Beach, FL","Berkeley, CA","Cambridge, MA",
  "Clearwater, FL","West Jordan, UT","Evansville, IN","Richardson, TX","Broken Arrow, OK",
  "Richmond, CA","League City, TX","Sugar Land, TX","Burbank, CA","Greeley, CO",
  "Sparks, NV","San Mateo, CA","Waterbury, CT","Provo, UT","El Monte, CA",
  "Norwalk, CA","High Point, NC","Murrieta, CA","Wichita Falls, TX","Green Bay, WI",
  "Antioch, CA","Everett, WA","Downey, CA","Costa Mesa, CA","Manchester, NH",
  "Miami Gardens, FL","Temecula, CA","Elgin, IL","Westminster, CO","Peoria, IL",
  "Gresham, OR","Rialto, CA","Pueblo, CO","San Marcos, CA","Centennial, CO",
  "Ventura, CA","Lakeland, FL","Boulder, CO","Inglewood, CA","Tyler, TX",
  "Lewisville, TX","Allen, TX","Sandy Springs, GA","Beaumont, TX","Odessa, TX",
  "Daly City, CA","Edison, NJ","Woodbridge, NJ","New Bedford, MA","Kenosha, WI",
  "Renton, WA","South Bend, IN","Vacaville, CA","Livonia, MI",
  "Menifee, CA","Buckeye, AZ","Lehi, UT","St. George, UT","Redwood City, CA",
  "Roswell, GA","Alhambra, CA","San Leandro, CA","Trenton, NJ","Chico, CA",
  "Livermore, CA","Bellingham, WA","Bloomington, MN","Alameda, CA","Bloomington, IN",
  "Kissimmee, FL","Carlsbad, CA","Whittier, CA","North Little Rock, AR","Federal Way, WA",
  "Redding, CA","Roanoke, VA","Brockton, MA","Iowa City, IA","Redondo Beach, CA",
];
// De-dupe (some city names collide across states and would cause React
// "duplicate key" warnings inside the SearchableSelect option list).
export const US_CITIES = Array.from(new Set(RAW_CITIES));
